// extracted by mini-css-extract-plugin
export default {"variable":"variable_variable__0-hl7","variableLabel":"variable_variableLabel__NuUvl","variableInput":"variable_variableInput__wzywS"};